<template>
  <v-card>
    <v-card-title class="d-flex">
      <v-icon small icon="cookie" />
      <span class="flex-grow-1 ml-2">{{ $t("cookieBanner.title") }}</span>
      <locale-switch class="flex-0-0" :css-class="languageTextClass" />
    </v-card-title>

    <v-divider />

    <v-card-text>
      <p class="mb-3">{{ $t("cookieBanner.text") }}</p>
    </v-card-text>

    <v-divider />

    <v-card-text>
      <v-checkbox
        v-model="selectedPreferences"
        class="cookie-preference-checkbox"
        :value="CookiePreferences.FUNCTIONAL"
        readonly
        disabled
        hide-details
      >
        <template #label>
          <p class="ml-2">
            <strong class="text-high-emphasis">{{ $t("cookieBanner.necessary.title") }}</strong>
            <br />
            <span>{{ $t("cookieBanner.necessary.text") }}</span>
          </p>
        </template>
      </v-checkbox>
    </v-card-text>

    <v-divider />

    <v-card-text class="text-center">
      <v-alert type="info" variant="text">
        <p class="mb-3">{{ $t("cookieBanner.thirdParty") }}</p>
        <dialog-cookie-statement show-language-selector>
          <template #activator="{ props }">
            <v-btn color="primary" variant="text" v-bind="props">{{ $t("cookieBanner.learnMore") }}</v-btn>
          </template>
        </dialog-cookie-statement>
      </v-alert>
    </v-card-text>

    <v-divider />

    <v-card-actions>
      <v-btn color="primary" variant="elevated" @click="emit('accept', preferenceOptions)">{{ $t("accept") }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup lang="ts">
import { useTheme } from "vuetify"

const emit = defineEmits<{
  (e: "accept", preferences: Array<string>): void
}>()

const preferenceOptions = [CookiePreferences.FUNCTIONAL]
const selectedPreferences = ref<Array<CookiePreferences>>([CookiePreferences.FUNCTIONAL])

const theme = useTheme()
const languageTextClass = computed(() => (theme.current.value.dark ? "text-white" : "text-black"))
</script>

<style>
.cookie-preference-checkbox .v-selection-control {
  align-items: flex-start;
}
</style>
